import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const ConvenienceIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M12.6553 59.9664H29.4085M146.681 59.9664H129.928M29.4085 59.9664H41.9735M29.4085 59.9664C29.4085 59.9664 34.1819 98.9039 36.4834 107.493C38.7848 116.082 47.8606 123.057 54.6491 123.057C60.0951 123.057 62.9847 123.057 62.9847 123.057H79.6558H96.3269C96.3269 123.057 100.857 123.057 104.662 123.057C111.35 123.057 120.348 116.755 122.83 107.493C124.148 102.571 129.928 59.9664 129.928 59.9664M129.928 59.9664H117.363M41.9735 59.9664H54.5385H79.6684H104.798H117.363M41.9735 59.9664L59.5341 29.5505M117.363 59.9664L99.8026 29.5505"
                stroke={color}
                strokeWidth="6"
            />
            <path d="M79.6689 76.3036V99.9228" stroke={color} strokeWidth="6" />
            <path d="M64.4111 76.3036V99.9229" stroke={color} strokeWidth="6" />
            <path d="M94.9277 76.3036V99.9228" stroke={color} strokeWidth="6" />
        </svg>
    );
};
